export default {
  // 首页轮播图
  homecasual: [],
  // 分类数组
  categoryList: [],
  // 首页的商品列表
  homeshoplist: [],
  // 推荐的商品列表
  recommendshoplist: [],
  // 商品详细信息
  goodsDetail: [],
  // 商品评论
  goodsComment: [],
  // 用户数据
  userInfo: {},
  // 购物车数据
  cartgoods: [],
  // 搜索结果
  searchresults: [],
  // 已选中要下单的商品
  selectedGoods: [],
  baseURL: "https://siteh5.lightcourse.com/pc/home",
  siteURL: "https://siteh5.lightcourse.com/",
  uniappURL: "https://crmh5.lightcourse.com/uniapp/",
  uploadURL: "https://siteh5.lightcourse.com/pc/uploads",
  crmURL: "https://crmh5.lightcourse.com/",
  mobile: false,
}



// WEBPACK FOOTER //
// ./src/store/state.js